/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.65"
        height="86.22"
        viewBox="0 0 82.65 86.22"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M35.96 35.8a2 2 0 0 1 2.29-1.48h.15l23.44 6a2 2 0 0 1-.84 3.91h-.14l-23.45-6a2 2 0 0 1-1.45-2.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M73.38 16.03a1.25 1.25 0 0 1 1.25 1.25 6.76 6.76 0 0 0 6.76 6.76 1.25 1.25 0 0 1 0 2.5 9.26 9.26 0 0 1-9.27-9.25 1.25 1.25 0 0 1 1.26-1.26ZM49.34 0a1.24 1.24 0 0 1 1.24 1.12v13a1.25 1.25 0 0 1-1.18 1.32 1.27 1.27 0 0 1-1.32-1.19V2.61a8.39 8.39 0 0 0-7.12 8v13.1a32.26 32.26 0 0 1-9.07 22.41l-.36.37-16.57 16.58a1.25 1.25 0 0 1-1.78 0 1.28 1.28 0 0 1-.35-.74v-8.41h-.15c-5.61.77-10 6.14-10.17 12.75V67c0 7.2 5.06 13 11.29 13.17h34.3V75a5.16 5.16 0 0 0-5-5.15h-13a1.24 1.24 0 0 1-1.22-1.27 1.26 1.26 0 0 1 1.09-1.22h13a7.65 7.65 0 0 1 7.61 7.44v6.66a1.24 1.24 0 0 1-1.12 1.24H14.07C6.27 82.7 0 75.65 0 67.02s6.27-15.68 14.07-15.68a1.27 1.27 0 0 1 1.25 1.13v6.72L29.75 44.8a29.75 29.75 0 0 0 8.7-20.52V10.87A10.87 10.87 0 0 1 49.32 0Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M73.38 16.03a1.25 1.25 0 0 1 1.25 1.25 6.76 6.76 0 0 0 6.76 6.76 1.25 1.25 0 0 1 0 2.5 9.26 9.26 0 0 1-9.27-9.25 1.25 1.25 0 0 1 1.26-1.26Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M58.96 9.61a7.65 7.65 0 0 1 7.52 6.23v.18h11.68a4.45 4.45 0 0 1 4.45 4.25v6.62a14.09 14.09 0 0 1-13.76 14.07h-5.44v44a1.26 1.26 0 0 1-1.12 1.25h-6.54a7.67 7.67 0 0 1-7.66-7.47V62.51a1.25 1.25 0 0 1 2.49-.13v16.16a5.16 5.16 0 0 0 5 5.21h5.38v-44a1.25 1.25 0 0 1 1.12-1.24h6.54a11.56 11.56 0 0 0 11.57-11.28v-6.7a2 2 0 0 0-1.81-2h-13a1.25 1.25 0 0 1-1.25-1.25 5.17 5.17 0 0 0-5-5.16h-9.74a1.24 1.24 0 0 1-1.31-1.18 1.25 1.25 0 0 1 1.18-1.32h9.75Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DogWithCollarIcon';

export default Icon;
